export default __webpack_public_path__ + "static/media/login_bg.29c570d7.png";